import {
  Facebook,
  Instagram,
  Linkedin,
  MessageCircle,
  Youtube,
} from 'lucide-react';
import { FaTiktok, FaXTwitter } from 'react-icons/fa6';

export const SOCIAL_PLATFORMS = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'x', label: 'X' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'whatsapp', label: 'WhatsApp' },
];

export const socialIconMap = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube,
  whatsapp: MessageCircle,
  x: FaXTwitter,
  tiktok: FaTiktok,
};

export const normalizeSocialLinks = (socialLinks = []) =>
  (Array.isArray(socialLinks) ? socialLinks : []).map((item, index) => ({
    platform: item.platform || 'facebook',
    label: item.label || SOCIAL_PLATFORMS.find((platform) => platform.value === item.platform)?.label || '',
    url: item.url || '',
    isActive: item.isActive !== false,
    sortOrder: Number.isFinite(Number(item.sortOrder)) ? Number(item.sortOrder) : index,
    openInNewTab: item.openInNewTab !== false,
  }));

export const isValidSocialUrl = (value) => {
  try {
    const parsed = new URL(String(value || '').trim());
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (_) {
    return false;
  }
};
